import React from 'react';
import { CurrentHouseProvider } from '@/context/CurrentHouseContext';
import RecordsContent from '@/components/documents/RecordsContent';

/**
 * Records page scoped to a specific property via its public ID in the URL.
 */
const Records: React.FC = () => {
	return (
		<CurrentHouseProvider>
			<RecordsContent />
		</CurrentHouseProvider>
	);
};

export const Route = createFileRoute({
	component: Records,
	validateSearch: (search) => {
		const pendingShareId = Number(search.pendingShareId);
		const page = Number(search.page);
		return {
			id: search.id ? String(search.id) : undefined,
			// The page a link into a record asks for: a task's source names the page it was read from,
			// and a link that lands on page 1 of a forty-page manual has not taken the reader there.
			page: Number.isInteger(page) && page > 0 ? page : undefined,
			// A pending share opens its review drawer via a dedicated key (its share id), kept separate
			// from `id` so that param stays a real document's opaque public_id.
			pendingShareId: Number.isFinite(pendingShareId) && pendingShareId > 0 ? pendingShareId : undefined,
		};
	},
});
